import React, { useState,useEffect} from 'react';
import {  Form, Select, Button,  useDispatch, useSelector, message } from '../../AntComponent';
import { getTimeZone,getCurrency,getCountry,getGenralSetting, saveGenralSetting } from '../../../store/actions/configuration-setting/GeneralSettingAction';
import { userProfile } from '../../../store/actions/userProfileAction';

export default function GeneralSetting(){
    const [form] =  Form.useForm();
    const dispatch = useDispatch(); 
    const { profileInfo } = useSelector(state => state.userPrf);
    const tenantID = profileInfo?.data?.appUser?.tenantID;
    const productID = profileInfo?.data?.tenantDetail?.kProductID;
    const appUserID = profileInfo?.data?.appUser?.appuserID;
    const locationID = profileInfo?.data?.location[0]?.locationID;
    const {timeZoneList,currencyList,countryList,getGnlSetting, success3,success4, saveGnlSetting, loading4} = useSelector(state => state.generalSetting)
    const [currencyName, setCurrencyName]= useState(null)
    const [defaultValue, setDefaultValue] = useState([]);
    const [showSuccessmsg, setShowsuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success4 : null;
    const configID = getGnlSetting?.data[0]?.genConfigID;
    const dateFormatOptions = [
        { label: "--Select--", value: "" },
        { label: "dd-mm-yyyy", value: "dd-MM-yyyy" },
        { label: "mm-dd-yyyy", value: "MM-dd-yyyy" },
        { label: "yyyy-mm-dd", value: "yyyy-MM-dd" },
    ];
    
    const timeFormatOptions = [
        { label: "--Select--", value: "" },
        { label: "12 Hours", value: "12" },
        { label: "24 Hours", value: "24" },
    ];

    useEffect(()=>{
        if(successmsg){
            if(saveGnlSetting?.message == "Updated Successfully"){
                message.success("Setting Updated Successfully")
                setShowsuccessmsg(false)
                getGeneralSet()
                dispatch(userProfile(appUserID));
            }
            else{
                message.error(saveGnlSetting?.message);
            }
        }
    },[successmsg])

    const timeZoneOption = timeZoneList?.data?.map((item) => {
        return {
            label: item.timeZoneName,
            value: item.timeZoneName
        }
    });
    const currencyOption = currencyList?.data?.map((item) => {
        return {
            label: item.currencyName,
            value: item.currencyID
        }
    });
    
    const countryOption = countryList?.data?.country?.map((item) => {
        return {
            label: item.countryName,
            value: item.countryID
        }
    });
    const handleCountryChange = (value) => {
        const selectedCurrency = currencyOption.find(option => option.value === value);
        setCurrencyName(selectedCurrency ? selectedCurrency.label : null);
    };
    function getCountryOption () {
        if(productID){
            let id = `${productID}/${0}`;
            dispatch(getCountry(id));
        }
    }
    function getGeneralSet (){
        let inputJson = {
            "TenantID": tenantID,
            "LocationID": locationID,
            "IsActive": true
        }
        dispatch(getGenralSetting(inputJson))
    }
    useEffect(() => {
        const apiValue = defaultValue ? defaultValue.countrytype : '';
        if (apiValue) {
            const arrayValue = apiValue.split(',').map(Number);
            form.setFieldsValue({
                country: arrayValue,
            });
        }
    }, [defaultValue]);
    
    const loadData = () => {
        form.setFieldsValue({ 
            dateFormat: getGnlSetting?.data[0]?.dateFormat !== null ? getGnlSetting?.data[0]?.dateFormat: "", 
            timeFormat: getGnlSetting?.data[0]?.timeFormat !== null ? getGnlSetting?.data[0]?.timeFormat: "",
            timeZone: getGnlSetting?.data[0]?.timeZone !== null ? getGnlSetting?.data[0]?.timeZone: "",
            currency: getGnlSetting?.data[0]?.currency !== null ? getGnlSetting?.data[0]?.currency: "",
         });
         setCurrencyName(getGnlSetting?.data[0]?.currency)
    }

    useEffect(()=>{
        loadData()
        setDefaultValue(getGnlSetting?.data[0])
    }, [success3])

    const saveGeneralSet = (values) =>{
        let val = values;
        // const parts = currencyName.split(' ');
        // const symbol = parts.length > 1 ? parts[1] : '';
        let inputJson =
        {
            "GenConfigID": configID,
            "DateFormat": val.dateFormat,
            "TimeFormat": val.timeFormat,
            "ServiceName": "Country",
            "TimeZone":  val.timeZone,
            "Currency": val.currency,
            "Countrytype":  val.country.toString(),
            "CountryValues": "",
            "TenantID": tenantID,
            "LocationID": locationID,
            "GenerateMode": "Manual",
            "CreatedBy": appUserID,
            "ModifiedBy": appUserID,
            "IsActive": true
        }
        dispatch(saveGenralSetting(inputJson))
        setShowsuccessmsg(true)
    }
    

    useEffect(() => {
        dispatch(getTimeZone());
        dispatch(getCurrency());
        getCountryOption()
        getGeneralSet()
    }, [dispatch, tenantID, productID]);
    return (
         <div className='m-3 mt-4'>
           <Form 
            className='configSettingCont'
            form = {form}
            onFinish={saveGeneralSet}
            layout='vertical'>
            <div className='TemplateDrawer row m-0'>
                <Form.Item label="Date Format" name="dateFormat" className='col-md-3 '
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select options={dateFormatOptions}  />
                </Form.Item>

                <Form.Item label="Time Format" name="timeFormat" className='col-md-3'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select options={timeFormatOptions}  />
                </Form.Item>

                <Form.Item label="Default Time Zone" name="timeZone" className='col-md-3'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select options={timeZoneOption}
                         />
                </Form.Item>

                <Form.Item label="Currency" name="currency" className='col-md-3'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select   options={currencyOption} onChange={handleCountryChange} />
                </Form.Item>

                <Form.Item label="Select Country" name="country" className='col-md-4'
                        rules={[{ required: true, message: "This field is required" }]}>
                        <Select   options={countryOption} mode="multiple"  
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        />
                </Form.Item>
                
            </div>
            <div className='row m-0 d-flex justify-content-end'>
                <Button className='dlv-save-btn m-4 mt-0' type="primary save-btn ms-1" htmlType='submit' loading={loading4} >Save</Button>
            </div>
            </Form>
        </div>
    )
}